import {ChartData} from "./chart-data";
import {GUID} from "app/shared/models/GUID-interface";

export class ChartDataGUID implements GUID{
    constructor(public readonly GUID: string, public readonly data: ChartData){
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/chart-data-GUID.ts